import React, { ReactElement } from 'react';
import { useUserContext } from '../../context/UserContext';
import { UserRoleEnum } from '../../model/currentuser/UserRole';
import SecuredComponent from './component/SecuredComponent';

interface Props {
  children: ReactElement;
  allowForRoles?: Array<UserRoleEnum>;
  additionalCheck?: boolean;
  elseChildren?: ReactElement;
}

const Secured = ({
  children, allowForRoles, additionalCheck = true, elseChildren = null,
}: Props): ReactElement => {
  const { pouzivatel } = useUserContext();

  return (
    <SecuredComponent
      pouzivatel={pouzivatel}
      allowForRoles={allowForRoles}
      additionalCheck={additionalCheck}
      elseChildren={elseChildren}
    >
      {children}
    </SecuredComponent>
  );
};

export default Secured;
